// TODO: move this to @nuorder/core?

// Global vars to track existing workers
const globalWebworkerRefs: {
    [workerName: string]: Worker[];
} = {};

function terminateGlobalWebWorker(workerPath: string, worker: Worker) {
    if (globalWebworkerRefs[workerPath]) {
        globalWebworkerRefs[workerPath] = globalWebworkerRefs[workerPath].filter(
            (existingWorker) => existingWorker !== worker
        );
    }

    worker.terminate();
}

interface ISmartWebWorker<D> {
    process: (data: D, onSuccess?: (event) => void, onError?: (error) => void) => void;
}
export function buildSmartWebWorker<D = any, R = any>(workerPath: string, maxWorkers = 1): ISmartWebWorker<D> {
    function process(data: D, onSuccess?: (event) => void, onError?: (error) => void) {
        const existingWorkersCount = (globalWebworkerRefs[workerPath] || []).length;
        if (existingWorkersCount >= maxWorkers) {
            const terminatingWorkers = globalWebworkerRefs[workerPath].splice(0, existingWorkersCount - maxWorkers + 1);

            terminatingWorkers.forEach((terminatingWorker) => {
                terminatingWorker.terminate();
            });
        }

        if (!globalWebworkerRefs[workerPath]) {
            globalWebworkerRefs[workerPath] = [];
        }

        const worker = new Worker(workerPath);
        globalWebworkerRefs[workerPath].push(worker);

        worker.postMessage(data);

        worker.onmessage = (event) => {
            if (onSuccess) {
                onSuccess({
                    ...event,
                    data: event.data as R,
                });
            }
            terminateGlobalWebWorker(workerPath, worker);
        };

        worker.onerror = (error) => {
            if (onError) {
                onError(error);
            }
            terminateGlobalWebWorker(workerPath, worker);
        };
    }

    return {
        process,
    };
}

export function createWorkerFallback(workerUrl: string): string | null {
    try {
        let blob;
        try {
            blob = new Blob(["importScripts('" + workerUrl + "');"], { type: "application/javascript" });
        } catch (e) {
            // @ts-ignore
            const blobBuilder = new (window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder)();
            blobBuilder.append(`importScripts('${workerUrl}');`);
            blob = blobBuilder.getBlob("application/javascript");
        }
        const url = window.URL || window.webkitURL;
        const blobUrl = url.createObjectURL(blob);

        return blobUrl;
    } catch (e) {
        // if it still fails, there is nothing much we can do
        // Raven.captureException(e);
        // eslint-disable-next-line no-console
        console.error(e);
    }
    return null;
}
